import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { exportExcelGrossProfit, getListGrossProfit } from 'services/gross-profit-report.service';
import DataTable from 'components/shared/DataTable/index';
import { formatPrice } from 'utils/index';

const TableReport = () => {
  const [data, setData] = useState({
    items: [],
    itemsPerPage: 25,
    page: 1,
    totalItems: 0,
    totalPages: 0,
  });
  const loadData = useCallback(() => {
    getListGrossProfit().then((e) => {
      setData(e);
    });
  }, []);
  useEffect(loadData, [loadData]);

  const revenue = (e) => (e?.repair_price ?? 0) * e?.total_count_error - e?.discount?.toFixed(0);
  const columns = useMemo(
    () => [
      {
        header: 'Nhóm lỗi',
        accessor: 'error_group_name',
      },
      {
        header: 'Mã lỗi',
        accessor: 'error_code',
      },
      {
        header: 'Tên lỗi',
        accessor: 'error_name',
      },
      {
        header: 'Giải pháp sửa chữa',
        accessor: 'solution_name',
      },
      {
        header: 'SL Sửa chữa',
        accessor: 'total_count_error',
      },
      {
        header: 'Giá dịch vụ',
        formatter: (e) => formatPrice(e?.repair_price, true, ','),
      },
      {
        header: 'Giảm giá',
        formatter: (e) => formatPrice(e?.discount?.toFixed(0), true, ','),
      },
      {
        header: 'Doanh thu',
        formatter: (e) => formatPrice(revenue(e), true, ','),
      },
      {
        header: 'Tiền hoa hồng',
        formatter: (value) => value?.commission ?? 0,
      },
      {
        header: 'Lãi gộp',
        formatter: (e) => formatPrice(revenue(e), true, ','),
      },
    ],
    [],
  );

  const exportExcel = () => {
    exportExcelGrossProfit()
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response?.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Báo cáo lãi gộp.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {})
      .finally(() => {});
  };

  const actions = [
    {
      globalAction: true,
      icon: 'fi fi-rr-inbox-out mr-2',
      type: 'success',
      content: 'Xuất báo cáo',
      onClick: () => exportExcel(),
    },
  ];

  return (
    <React.Fragment>
      <DataTable actions={actions} noSelect noPaging columns={columns} data={data?.items} />
    </React.Fragment>
  );
};

export default TableReport;
